// extracted by mini-css-extract-plugin
export default {"root_calendar":"style-module__root_calendar___J36J1"};
    if(module.hot) {
      // 1697460473068
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  